import {
  TnplAcceptableRiskLevel,
  TnplShippingPolicyType,
} from "@redotech/redo-tnpl-settings-common/tnpl-settings";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const EditTnplContractTemplateSchema = z.object({
  name: z.string(),
  productIds: z.array(z.number()),
  trialLength: z.number().min(1),
  trialEndChargeDelay: z.number().min(0),
  cartValueLimit: z.number().min(0).optional(),
  cartMaxTnplItems: z.number().min(0).optional(),
  shippingPolicy: z
    .discriminatedUnion("type", [
      z.object({ type: z.literal(TnplShippingPolicyType.REGULAR) }),
      z.object({
        type: z.literal(TnplShippingPolicyType.CUSTOM),
        customDeliveryProfileId: z.string().optional(),
      }),
    ])
    .optional(),
});
export type EditTnplContractTemplate = z.infer<
  typeof EditTnplContractTemplateSchema
>;

export const editTryFirstPlan = {
  name: "editTryFirstPlan" as const,
  input: z.object({
    plan: EditTnplContractTemplateSchema,
    acceptableOrderRisk: createEnum(TnplAcceptableRiskLevel),
    tnplOrderTags: z
      .object({
        enabled: z.boolean(),
        onCreated: z.array(z.string()),
        onAuthorized: z.array(z.string()),
        onStart: z.array(z.string()),
      })
      .optional(),
  }),

  output: z.object({
    success: z.boolean(),
    planId: z.string().optional(),
    shopifySync: z.boolean().optional(),
  }),
};
